import type { CampRegistration } from '../types';

export interface EmailServiceResponse {
  success: boolean;
  error?: string;
  data?: any;
}

export class EmailService {
  private static baseUrl = window.location.origin;

  static async sendWelcomeEmail(registration: Omit<CampRegistration, 'id' | 'registrationDate'>): Promise<EmailServiceResponse> {
    try {
      const apiUrl = `${this.baseUrl}/api/send-welcome-email`;
      console.log('Sending email request to:', apiUrl);

      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        }, body: JSON.stringify({
          email: registration.email,
          name: registration.name,
          age: registration.age,
        }),
      });

      let data;
      try {
        const text = await response.text();
        try {
          data = JSON.parse(text);
        } catch {
          // If response is not JSON, use the text as error info if request failed
          if (!response.ok) {
            console.error('Email API error (non-JSON):', text);
            return {
              success: false,
              error: `Server error (${response.status}): ${text || 'Unknown error'}`,
            };
          }
          // If 200 OK but not JSON (unlikely for our API but possible)
          data = { message: text };
        }
      } catch (readError) {
        return {
          success: false,
          error: 'Failed to read response from server',
        };
      }

      if (!response.ok) {
        console.error('Email API error:', data);
        return {
          success: false,
          error: data.error || 'Failed to send email',
        };
      }

      console.log('Email sent successfully:', data);
      return {
        success: true,
        data,
      };
    } catch (error) {
      console.error('Email service error:', error);
      return {
        success: false,
        error: 'Network error occurred while sending email',
      };
    }
  }

  /**
   * Validates if email sending is properly configured
   */
  static isConfigured(): boolean {
    // In a real app, you might want to check for API keys, etc.
    return true;
  }
}
